<script setup>
import MetricChart from './MetricChart.vue'

defineProps({
  title: { type: String, required: true },
  status: { type: String, default: null },
  headline: { type: String, required: true },
  details: { type: Array, required: true },
  series: { type: Array, required: true },
  xMin: { type: Number, required: true },
  xMax: { type: Number, required: true },
})

const STATUS = {
  good: { label: 'Good', text: 'text-[#006300]', bg: 'bg-[#006300]/10', dot: 'bg-[#006300]' },
  watch: { label: 'Watch', text: 'text-[#8a5a00]', bg: 'bg-[#fab219]/15', dot: 'bg-[#fab219]' },
  alert: { label: 'Alert', text: 'text-[#d03b3b]', bg: 'bg-[#d03b3b]/10', dot: 'bg-[#d03b3b]' },
}
</script>

<template>
  <div class="rounded-lg border bg-card p-3">
    <div class="flex items-center gap-1.5">
      <span class="text-sm font-medium text-muted-foreground truncate">{{ title }}</span>
      <span
        v-if="status"
        class="ml-auto inline-flex shrink-0 items-center gap-1 rounded-full px-1.5 py-0.5 text-xs font-semibold"
        :class="[STATUS[status].bg, STATUS[status].text]"
      >
        <span class="size-1.5 rounded-full" :class="STATUS[status].dot"></span>
        {{ STATUS[status].label }}
      </span>
    </div>
    <div class="mt-1.5 text-sm font-medium leading-snug">{{ headline }}</div>
    <div v-if="details.length" class="mt-1.5 space-y-0.5">
      <div v-for="d in details" :key="d" class="text-xs text-muted-foreground">{{ d }}</div>
    </div>
    <template v-if="series.length">
      <div v-if="series.length > 1" class="mt-2 flex flex-wrap gap-x-3 gap-y-0.5">
        <span
          v-for="s in series"
          :key="s.label"
          class="inline-flex items-center gap-1 text-[10px] text-muted-foreground"
        >
          <span class="size-1.5 rounded-full" :style="{ backgroundColor: s.color }"></span>{{ s.label }}
        </span>
      </div>
      <div class="mt-1.5 h-16 border-b border-border/40">
        <MetricChart :series="series" :x-min="xMin" :x-max="xMax" sparkline />
      </div>
    </template>
  </div>
</template>
